import KyeAddressSearch from './address-search'

export default KyeAddressSearch



// WEBPACK FOOTER //
// ./src/public/components/kye-address-search/index.js